export function formatFileSize(size: number) {
	if (!size) {
		return;
	}
	return size < 1024 * 1024
		? `${(size / 1024).toFixed(1)} KB`
		: `${(size / 1024 / 1024).toFixed(1)} MB`;
}
